// Google Analytics 4 - Event Tracking Utilities
// Uses the global gtag function defined in index.html

// Track page views (called on route change)
export const trackPageView = (path, title) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
  });
};

// Track custom events
export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
};

// --- Specific Event Helpers ---

export const trackSignUp = (method = 'email', language = 'es') => {
  trackEvent('sign_up', { method, language });
};

export const trackLogin = (method = 'email') => {
  trackEvent('login', { method });
};

export const trackLessonCompleted = (lessonId, lessonTitle) => {
  trackEvent('lesson_completed', {
    lesson_id: lessonId,
    lesson_title: lessonTitle,
  });
};

export const trackExerciseSubmitted = (exerciseId, exerciseTitle) => {
  trackEvent('exercise_submitted', {
    exercise_id: exerciseId,
    exercise_title: exerciseTitle,
  });
};

export const trackSubscriptionStarted = (plan) => {
  trackEvent('begin_checkout', {
    currency: 'EUR',
    value: plan === 'monthly' ? 9.99 : 99.0,
    items: [{ item_name: `ESSENCIA ${plan}` }],
  });
};

export const trackSubscriptionCompleted = (plan) => {
  trackEvent('purchase', {
    currency: 'EUR',
    value: plan === 'monthly' ? 9.99 : 99.0,
    items: [{ item_name: `ESSENCIA ${plan}` }],
  });
};

export const trackChatStarted = () => {
  trackEvent('chat_started');
};

export const trackJournalEntry = () => {
  trackEvent('journal_entry_created');
};

export const trackDailyFeeling = () => {
  trackEvent('daily_feeling_submitted');
};
